import { get } from './request'

export let loadStandardsList = (success, failure) => get('/api/standards-list', success, failure)